export const paths = {
  payPage: {
    main: "/",
    mainWithToken: "/:token",
  },
};

export const PAYALL_URL = process.env.REACT_APP_ENV === "production" ? "https://artymys.com/account/order/" : "https://test.artymys.com/account/order/";
